import cx from 'classnames';
import type {FC, ReactNode} from 'react';
import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {shouldUseNamedStepsNav} from '~/common/utils/event_utils';
import {EnvelopeProvider} from '../contexts/EnvelopeContext';
import {CardDesignNavigator} from './CardDesignNavigator/CardDesignNavigator';
import {NavBottom} from './NavBottom/NavBottom';

interface MobileBottomUIProps {
  mwNavBottom?: ReactNode;
}

export const MobileBottomUI: FC<MobileBottomUIProps> = () => {
  const isDesktop = useIsLargishAndUp();
  const currentRoute = useCurrentRoute();

  // We only want to show the bottom ui on step 1
  const showCtaNavBottom = currentRoute.id === 1 && !currentRoute.meta.editing;

  return (
    <EnvelopeProvider>
      <div
        className={cx('card-design__nav-bottom__buttons_wrapper step4-mobile-card-design', {
          'card-design__nav-bottom__buttons_wrapper--named-steps-nav': shouldUseNamedStepsNav(),
        })}
      >
        <CardDesignNavigator />
        {!isDesktop && !showCtaNavBottom && (
          <div className="card-design__external-bottom-nav" id="card-design__external-bottom-nav" />
        )}
        {!isDesktop && showCtaNavBottom && (
          <NavBottom allBackgroundsLoaded currentRoute={currentRoute} />
        )}
      </div>
    </EnvelopeProvider>
  );
};
